import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import {
  HashRouter as Router,
  Link
} from 'react-router-dom'
import Chance from '../utils/Chance'

export default class Home extends React.Component {
  constructor(props: RouteComponentProps) {
    super(props)
  }

  render() {
    return (
      <Router>
        <h1>Monster Lanes</h1>
        <Link to={`/game/4/4/${Chance.upto(999999)}`}>Play Now!</Link>
      </Router>
    )
  }
}
